// extracted by mini-css-extract-plugin
export default {"header":"Header_header__WAROc","header-content-wrapper":"Header_header-content-wrapper__gJNrR"};